import api from '../lib/api'
import type { Locale } from '../i18n/locales'

export function updateUserLanguage(language: Locale): Promise<{ language: string }> {
  return api.patch('/auth/me/language', { language }).then((r) => r.data)
}
